module.exports = __webpack_public_path__ + "img/ditan_xc3.6f7ea287.jpg";